module.exports = __webpack_public_path__ + "img/t2-18.a0dbb2a5.svg";